export default __webpack_public_path__ + "static/media/real_time_collaboration.a58ca027.svg";